export const fireboundHighlight = {
  "id": "Fire Boundaries Highlight",
  "source": "firebounds",
  "source-layer": "Fire_Region_Statistics_slimdata",
  "type": "fill",
  "layout": {
    "visibility": "visible"
  },
  "paint": {
    "fill-outline-color": "#f52c2c",
    "fill-color": "hsla(0, 91%, 57%, .4)",
  },
  "metadata": {
    "style": "none",
    "data": "forestDisturbance"
  }
}